import dynamic from 'next/dynamic';
import { ComponentProps } from './RoomUpgrade.types';

export const RoomUpgrade = dynamic<ComponentProps>(() => import('./RoomUpgrade').then(module => module.RoomUpgrade));
